import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getLostJobReasons = async ({ id }: JsonDataItem) => {
  const { data } = await baseQuery(`lost-job-reasons?search_history_id=${id}`);

  return data;
};
